import { format } from "date-fns";
import { to12HourTime } from "@/components/news-alerts/shared/utils";
import type { ResultOf } from "@/data-access/graphql";
import type { ScheduledBriefingFragment } from "@/data-access/news-alerts/fragments/scheduled-briefing-fragments";
import type { GetScheduledItems } from "@/data-access/news-alerts/queries/scheduler-items-queries";
import { transformNewsAlertToTableAlert } from "./news-alerts.helpers";
import type { TableAlert } from "./news-alerts.slice";

export type SchedulerItemFromApi = NonNullable<
  ResultOf<typeof GetScheduledItems>["schedulerItems"]
>[number];

type ScheduledBriefingRowInput = ResultOf<typeof ScheduledBriefingFragment>;

export const transformScheduledBriefingToTableRow = (
  briefing: ScheduledBriefingRowInput,
): TableAlert => {
  const formattedTime = to12HourTime(briefing.sendAt);
  return {
    id: briefing.id,
    name: briefing.name,
    schedule: `${briefing.sendOn} at ${formattedTime} ${briefing.timezone}`,
    recipients: briefing.recipients.length,
    lastUpdated: format(new Date(briefing.updatedAt), "MM/dd/yyyy hh:mm a"),
    createdBy: briefing.createdBy.name,
    scheduleType: briefing.scheduleType,
  };
};

export const transformSchedulerItemsToTableRows = (
  items: readonly SchedulerItemFromApi[],
): TableAlert[] =>
  items.map((item) =>
    item.__typename === "ScheduledBriefingType"
      ? transformScheduledBriefingToTableRow(item)
      : transformNewsAlertToTableAlert(item),
  );
